import React from 'react';

import BoxGraphic from './components/boxGraphic';
import BoxMonth from './components/boxMonth';
import BoxEnd from './components/boxEnd';

import Constants from '~/utils/constants';
import Container from '~/components/container';
import { useUserRole } from '~/hooks/contexts/useUserRole';

const Home: React.FC = () => {
  const { hasAnyRole } = useUserRole();

  const validateRoles = () =>
    hasAnyRole([
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ]);

  return (
    <Container title="Dashboard B.I.">
      {validateRoles() && (
        <>
          <BoxEnd />
          <BoxGraphic />
          <BoxMonth />
        </>
      )}
    </Container>
  );
};

export default Home;
